import { ProfileViewResponse } from "@/generated-api";
import { useStandaloneMode } from "@/hooks/useStandaloneMode";
import { FavoriteButton } from "./FavoriteButton";
import MessageButton from "./MessageButton";
import { getIOSVersion } from "@/lib/utils";
import Ios26MessageButton from "./Ios26MessageButton";

export default function MessageBottomBar({
  userId,
  profileView,
  isSelfView = false,
}: {
  userId: string;
  profileView: ProfileViewResponse;
  isSelfView?: boolean;
}) {
  const isStandalone = useStandaloneMode();
  const iosVersion = getIOSVersion();

  const detachingBarIosVersions = ["26.0"];

  const versionString = iosVersion
    ? `${iosVersion.major}.${iosVersion.minor}`
    : null;

  if (versionString && detachingBarIosVersions.includes(versionString)) {
    return (
      <div
        className={`md:hidden min-w-[320px] w-[50vw] !fixed ${
          isStandalone ? "!bottom-7" : "!bottom-3"
        } inset-x-0 mx-auto bg-white/20 backdrop-blur-md px-4 z-20 pointer-events-auto rounded-full border border-zinc-100/20`}
      >
        <div className="flex flex-row justify-between items-center py-1">
          <FavoriteButton active={profileView.is_favorite} userId={userId} />
          <Ios26MessageButton
            profileView={profileView}
            userId={userId}
            isSelfView={isSelfView}
            className="py-6"
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 bg-black px-6 border-t-[#303030] border-t z-20 pb-[calc(env(safe-area-inset-bottom)+0.25rem)]"
    >
      <div className="flex flex-row justify-between items-center py-3">
        <FavoriteButton active={profileView.is_favorite} userId={userId} />
        <MessageButton
          profileView={profileView}
          userId={userId}
          isSelfView={isSelfView}
          className="mr-4 py-6"
        />
      </div>
    </div>
  );
}
